import { render, staticRenderFns } from "./error.vue?vue&type=template&id=2c5cba47&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./error.vue?vue&type=style&index=0&id=2c5cba47&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./error.vue?vue&type=style&index=1&id=2c5cba47&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2c5cba47",
  "36c6218c"
  
)

export default component.exports